export const GQL_QUERIES = {
    
    getSelfService: `
      query GetSelfService {
        getSelfService{
          selfService
        }
      }
    `,
    getSelfServiceViewOnly: `
      query getSelfServiceViewOnly($emplid: String!) {
        getSelfServiceViewOnly(emplid: $emplid) {
          selfService
        }
      }
    `,
    
    personSearch: `
    query personSearch($input: PersonSearchInput!) {
        personSearch(input: $input) {
          columns {
            field
            flex
            headerName
            renderCell
            width
            default
          }
          results
        }
      }
    `,

    submitStudentDecision: `
      mutation submitStudentDecision($decision: String!) {
        submitStudentDecision(decision: $decision) {
          selfService
        }
      }    
    `
    
    // ... other queries
  };
  